<template>
  <v-list-tile @click="alterarDados">
    <v-list-tile-content>
      <v-list-tile-title>Alterar Dados</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {mutationTypes} from "@/commons/constants";

export default {
  name: 'LicitacaoAtualizacaoAcoesAlterarDados',
  computed: {
    ...mapState(['licitacao'])
  },
  methods: {
    ...mapMutations([
      mutationTypes.MOSTRAR_MENSAGEM_WARNING
    ]),
    alterarDados() {
      const statusPermitido = ['AGUARDANDO_ABERTURA', 'SUSPENSO'].includes(this.licitacao.status)

      if (!statusPermitido) {
        this.mostrarNotificacaoWarning('Para alterar as informações, a licitação deve estar com a situação “Aguardando Abertura” ou “Suspensa"')
        return
      }

      this.$root.$emit('alterarDadosLicitacao')
    }
  }
}
</script>

<style scoped lang="stylus">
</style>